// Data-driven "this country has no JLPT exam location, try this nearby one
// instead" mapping, ISO 3166-1 alpha-2 code -> ISO 3166-1 alpha-2 code.
// Seeded per NIH-43 with Portugal -> Spain (Portugal has no current JLPT
// overseas test site; Spain is the nearest one with real, active sites).
// Belgium's own sites (Leuven, Ghent) are suspended for 2026, so it maps to
// the Netherlands (Leiden) - the closest country with a real, active site,
// nearer than Germany's Duesseldorf or France's Paris.
// Add more entries here as other gaps are found - no code changes needed
// anywhere that reads this map.
export const JLPT_COUNTRY_FALLBACKS: Record<string, string> = {
    PT: "ES",
    BE: "NL",
};
